import { API } from '../Api';

export interface CommentVoter {
  userId: string;
  username?: string;
  fullName?: string;
  avatar?: string;
  likeType: number; // 1 = like, -1 = dislike
}

// Danh sách người like/dislike 1 bình luận. type: 1=like, -1=dislike, bỏ trống=tất cả.
export const getCommentVoters = (commentId: string, type?: number) => {
  const params: Record<string, number> = {};
  if (type !== undefined) params.type = type;
  return API.get<CommentVoter[]>(
    `/v1/post-service/comments/${commentId}/voters`,
    { params }
  ).then((res) => res.data ?? []);
};
